import { Injectable } from "@angular/core";
import { ValidatorFn, AbstractControl, Validators } from "@angular/forms";

@Injectable({
  providedIn: "root",
})
export class EmailValidatorService {
  // Custom validator function
  static createEmailValidator(): ValidatorFn {
    return (c: AbstractControl): { [key: string]: boolean } | null => {
      /**
       * Examples:
       * a@a.com - won't match, .com isn't checked against
       * a\a@a - won't match, but v
       * a\aa@a - will match, the regex after \ requires AT LEAST ONE ANY and then AT LEAST ONE [symbols and chars and nums]
       *
       * max-length 254 - this means anything with a .com ( or other TOP LEVEL DOMAIN ) will breach this number at max validation from the
       *                  Angular email validator.  This is not a bug, handle your own true "full email" max-length values.
       */
      // This does all the valdation except enforcing ".com" or similar suffix
      let errors = Validators.email(c);
      if (errors?.email) {
        return errors;
      }

      // This is the exact regex from the backend validation - 12/2/2022
      if (!c.value) {
        return; // no value to test, it's fine
      }

      let regex = new RegExp(
        "^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$",
      );
      const regexAssertion = regex.test(c.value);
      if (!regexAssertion) {
        return { email: true };
      }

      return null;
      // return (!c.value || regex.test(c.value)) ? null : { email: true }; // !c.value means a required validator would be required to enforce valued existence
    };
  }
}
